/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTKT1TrustedBankVisas, updateTKT1TrustedBankVisa, createTKT1TrustedBankVisa } from '../actions';
import { getTKT1BankBrands } from '../actions';
import { getTKT1TrustedPersonInfos } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import Pagination from "../components/Pagination";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS } from "../utils";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Card,
  Form,
  Table,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Modal,
  Image,
  Toast,
  ToastContainer
} from "react-bootstrap";
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaExternalLinkAlt, FaPlus } from 'react-icons/fa';
import IframeModal from '../components/IframeModal/IframeModal';
import Select from 'react-select';
import TrustedPersonInfoModal from '../components/TrustedPersonInfoModal/TrustedPersonInfoModal';

class TKT1TrustedBankVisa extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 20,
    sortBy: 'created_at',
    sortOrder: -1,
    search: '',
    is_active: ''
  }

  initShowColumns = {
    MID: true,
    bank_name: true,
    trust_person_mid: true,
    account_holder_name: true,
    account_holder_name_english: true,
    visa_number: true,
    valid_month: true,
    valid_year: true,
    type: true,
    status: true,
    is_active: true,
    cvvx: false,
    deposit_bank_account_mid: false,
    opening_fee: false,
    annual_fee: false,
    created_at: false,
    ref_etsy_info_pack_mid: true
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      loading: false,
      showConfigModal: false,
      showEditModal: false,
      showViewModal: false,
      showCreateModal: false,
      showBankInfoModal: false,
      showTrustedPersonModal: false,
      showDepositAccountModal: false,
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: '',
      selectedVisa: null,
      selectedBankInfo: null,
      selectedTrustedPersonInfo: null,
      selectedDepositAccountInfo: null,
      isEditMode: false,
      showToast: false,
      toastMessage: '',
      toastType: 'success',
      bankBrands: [],
      trustedPersons: [],
      editFormData: {
        bank_name: '',
        trust_person_mid: '',
        branch_name: '',
        type: '',
        visa_number: '',
        valid_month: '',
        valid_year: '',
        cvvx: '',
        deposit_bank_account_mid: '',
        account_note: '',
        status: 'active',
        ref_etsy_info_pack_mid: '',
        opening_fee: 0,
        annual_fee: 0,
        is_active: true
      }
    };
  }

  componentDidMount() {
    document.title = 'TKT1 Trusted Bank Visa';
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    
    const hasUrlParams = queryStringFromUrl && queryStringFromUrl.length > 1;
    
    if (hasUrlParams) {
      const queryObject = queryString.parse(queryStringFromUrl);
      
      ['itemsPerPage', 'currentPage'].map(key => {
        if (queryObject[key]) {
          queryObject[key] = parseInt(queryObject[key])
        }
      })
      if (queryObject.sortOrder) {
        queryObject.sortOrder = parseInt(queryObject.sortOrder);
      }
      
      const viewConfig = JSON.parse(localStorage.getItem('TKT1TrustedBankVisa_ViewConfig'));
      
      const restoredQuery = {
        ...this.initQuery,
        ...queryObject
      };

      this.setState({
        query: restoredQuery,
        showColumns: {
          ...this.initShowColumns,
          ...(viewConfig || {})
        }
      }, () => {
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1TrustedBankVisas(apiQuery);
        this.loadDropdownData();
      })
    } else {
      var query = JSON.parse(localStorage.getItem('tkt1_trusted_bank_visa_query'));
      var viewConfig = JSON.parse(localStorage.getItem('TKT1TrustedBankVisa_ViewConfig'));
      
      if (query) {
        const restored = {
          ...this.initQuery,
          ...query
        };
        restored.itemsPerPage = parseInt(restored.itemsPerPage || this.initQuery.itemsPerPage);
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);

        this.setState({
          query: restored,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1TrustedBankVisas(apiQuery);
          this.loadDropdownData();
        })
      } else {
        this.setState({
          query: this.initQuery,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1TrustedBankVisas(apiQuery);
          this.loadDropdownData();
        })
      }
    }
  }

  loadDropdownData = async () => {
    try {
      // Load Bank Brands
      const bankBrandQuery = {
        currentPage: 1,
        itemsPerPage: 1000,
        sortBy: 'bank_name',
        sortOrder: 1,
        search: '',
        is_active: 'true'
      };
      await this.props.getTKT1BankBrands(bankBrandQuery);

      // Load Trusted Persons
      const trustedPersonQuery = {
        currentPage: 1,
        itemsPerPage: 1000,
        sortBy: 'MID',
        sortOrder: 1,
        search: '',
        is_deleted: 'false'
      };
      await this.props.getTKT1TrustedPersonInfos(trustedPersonQuery);
    } catch (error) {
      console.error('Error loading dropdown data:', error);
    }
  }

  showToast = (message, type = 'success') => {
    this.setState({
      showToast: true,
      toastMessage: message,
      toastType: type
    });
    
    setTimeout(() => {
      this.setState({ showToast: false });
    }, 3000);
  }

  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleClearSearch = () => {
    this.setState({
      query: { ...this.state.query, search: '' }
    }, () => {
      this.handleSearch();
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleSearch = () => {
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim(),
      is_active: this.state.query.is_active
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.updateUrl(trimmedQuery)
    this.props.getTKT1TrustedBankVisas(apiQuery);
    localStorage.setItem('tkt1_trusted_bank_visa_query', JSON.stringify(trimmedQuery));
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  prepareApiQuery = (query) => {
    const { showColumns, search, is_active, show_sidebar, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: search ? search.trim() : ''
    };
    
    if (is_active && is_active.trim()) {
      apiQuery.is_active = is_active;
    }
    
    return apiQuery;
  }

  updateUrl = (query) => {
    const { history } = this.props;
    const { showColumns, show_sidebar, ...urlQuery } = query;
    
    const queryStr = queryString.stringify(urlQuery);

    history.push({
      pathname: '/admin/tkt1-bank/trusted-bank-visa',
      search: queryStr,
    });
  }

  handleCreateClick = () => {
    this.setState({
      showCreateModal: true,
      selectedVisa: null,
      isEditMode: false,
      editFormData: {
        bank_name: '',
        trust_person_mid: '',
        branch_name: '',
        type: '',
        visa_number: '',
        valid_month: '',
        valid_year: '',
        cvvx: '',
        deposit_bank_account_mid: '',
        account_note: '',
        status: 'active',
        ref_etsy_info_pack_mid: '',
        opening_fee: 0,
        annual_fee: 0,
        is_active: true
      }
    });
  }

  handleFormChange = (field, value) => {
    this.setState(prevState => ({
      editFormData: {
        ...prevState.editFormData,
        [field]: value
      }
    }));
  }

  handleSubmitEdit = async () => {
    try {
      this.setState({ loading: true });
      
      const { selectedVisa, editFormData } = this.state;
      
      console.log('Submitting form:', { isEditMode: this.state.isEditMode, editFormData });
      
      if (this.state.isEditMode) {
        // Update existing visa
        console.log('Updating trusted bank visa:', selectedVisa._id, editFormData);
        await this.props.updateTKT1TrustedBankVisa(selectedVisa._id, editFormData);
        this.showToast('Cập nhật thẻ Visa tin cậy thành công!', 'success');
      } else {
        // Create new visa
        console.log('Creating trusted bank visa:', editFormData);
        await this.props.createTKT1TrustedBankVisa(editFormData);
        this.showToast('Thêm thẻ Visa tin cậy mới thành công!', 'success');
      }
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      await this.props.getTKT1TrustedBankVisas(apiQuery);
      
      // Close modals
      this.setState({
        showEditModal: false,
        showCreateModal: false,
        selectedVisa: null,
        isEditMode: false,
        loading: false
      });
      
      console.log('Trusted bank visa saved successfully');
      
    } catch (error) {
      console.error('Error saving trusted bank visa:', error);
      this.showToast('Có lỗi xảy ra khi lưu dữ liệu!', 'error');
      this.setState({ loading: false });
    }
  }

  handleCloseCreateModal = () => {
    this.setState({
      showCreateModal: false,
      selectedVisa: null,
      isEditMode: false
    });
  }

  handleViewClick = (visa) => {
    this.setState({
      showViewModal: true,
      selectedVisa: visa,
      isEditMode: false
    });
  }

  handleEditClick = (visa) => {
    this.setState({
      showEditModal: true,
      selectedVisa: visa,
      isEditMode: true,
      editFormData: {
        bank_name: visa.bank_name || '',
        trust_person_mid: visa.trust_person_mid || '',
        branch_name: visa.branch_name || '',
        type: visa.type || '',
        visa_number: visa.visa_number || '',
        valid_month: visa.valid_month || '',
        valid_year: visa.valid_year || '',
        cvvx: visa.cvvx || '',
        deposit_bank_account_mid: visa.deposit_bank_account_mid || '',
        account_note: visa.account_note || '',
        status: visa.status || 'active',
        ref_etsy_info_pack_mid: visa.ref_etsy_info_pack_mid || '',
        opening_fee: visa.opening_fee || 0,
        annual_fee: visa.annual_fee || 0,
        is_active: visa.is_active !== undefined ? visa.is_active : true
      }
    });
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedVisa: null,
      isEditMode: false
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedVisa: null,
      isEditMode: false
    });
  }

  handleConfigChange = (column, value) => {
    this.setState(prevState => ({
      showColumns: {
        ...prevState.showColumns,
        [column]: value
      }
    }));
  }

  handleSaveConfig = () => {
    localStorage.setItem('TKT1TrustedBankVisa_ViewConfig', JSON.stringify(this.state.showColumns));
    this.setState({ showConfigModal: false });
  }

  handleCloseConfigModal = () => {
    this.setState({ showConfigModal: false });
  }

  handleViewBankInfo = (bankInfo) => {
    this.setState({
      showBankInfoModal: true,
      selectedBankInfo: bankInfo
    });
  }

  handleViewTrustedPersonInfo = (trustedPersonInfo) => {
    this.setState({
      showTrustedPersonModal: true,
      selectedTrustedPersonInfo: trustedPersonInfo
    });
  }

  handleViewDepositAccountInfo = (depositAccountInfo, visa) => {
    this.setState({
      showDepositAccountModal: true,
      selectedDepositAccountInfo: depositAccountInfo,
      selectedVisa: visa
    });
  }

  handleCloseBankInfoModal = () => {
    this.setState({
      showBankInfoModal: false,
      selectedBankInfo: null
    });
  }

  handleCloseTrustedPersonModal = () => {
    this.setState({
      showTrustedPersonModal: false,
      selectedTrustedPersonInfo: null
    });
  }

  handleCloseDepositAccountModal = () => {
    this.setState({
      showDepositAccountModal: false,
      selectedDepositAccountInfo: null
    });
  }

  handleEtsyInfoPackClick = (refEtsyInfoPackMid) => {
    if (refEtsyInfoPackMid) {
      this.setState({
        showIframeModal: true,
        iframeUrl: `/admin/tkt1-etsy/etsy-info-pack-detail/${refEtsyInfoPackMid}`,
        iframeTitle: `Etsy Info Pack Detail - ${refEtsyInfoPackMid}`
      });
    }
  }

  handleCloseIframeModal = () => {
    this.setState({
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: ''
    });
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim(),
      is_active: this.state.query.is_active
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);

    this.setState({
      query: { ...this.state.query, currentPage: newPage },
    }, () => {
      this.setState({ trustedBankVisas: [] }, () => {
        this.updateUrl(trimmedQuery)
        this.props.getTKT1TrustedBankVisas(apiQuery);
        localStorage.setItem('tkt1_trusted_bank_visa_query', JSON.stringify(trimmedQuery));
      })
    })
  }

  renderSearchFilter = () => {
    return <>
      <Row className="mb-3">
        <Col md="4">
          <InputGroup>
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm theo tên ngân hàng, MID, số Visa..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Trạng thái</InputGroup.Text>
            <Form.Select
              value={this.state.query.is_active}
              onChange={(e) => {
                const newQuery = { ...this.state.query, is_active: e.target.value };
                this.setState({ query: newQuery });
                localStorage.setItem('tkt1_trusted_bank_visa_query', JSON.stringify(newQuery));
                
                const trimmedQuery = {
                  ...newQuery,
                  search: this.state.query.search.trim(),
                  is_active: newQuery.is_active
                };
                const apiQuery = this.prepareApiQuery(trimmedQuery);
                this.updateUrl(trimmedQuery);
                this.props.getTKT1TrustedBankVisas(apiQuery);
              }}
            >
              <option value="">Tất cả</option>
              <option value="true">Hoạt động</option>
              <option value="false">Không hoạt động</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Sắp xếp</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={(e) => {
                const newQuery = { ...this.state.query, sortBy: e.target.value };
                this.setState({ query: newQuery });
                localStorage.setItem('tkt1_trusted_bank_visa_query', JSON.stringify(newQuery));
                
                const trimmedQuery = {
                  ...newQuery,
                  search: this.state.query.search.trim(),
                  is_active: this.state.query.is_active
                };
                const apiQuery = this.prepareApiQuery(trimmedQuery);
                this.updateUrl(trimmedQuery);
                this.props.getTKT1TrustedBankVisas(apiQuery);
              }}
            >
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
              <option value="bank_name">Tên ngân hàng</option>
              <option value="visa_number">Số Visa</option>
              <option value="valid_year">Năm hết hạn</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Thứ tự</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortOrder}
              onChange={(e) => {
                const newQuery = { ...this.state.query, sortOrder: parseInt(e.target.value) };
                this.setState({ query: newQuery });
                localStorage.setItem('tkt1_trusted_bank_visa_query', JSON.stringify(newQuery));
                
                const trimmedQuery = {
                  ...newQuery,
                  search: this.state.query.search.trim(),
                  is_active: this.state.query.is_active
                };
                const apiQuery = this.prepareApiQuery(trimmedQuery);
                this.updateUrl(trimmedQuery);
                this.props.getTKT1TrustedBankVisas(apiQuery);
              }}
            >
              <option value="-1">Giảm dần</option>
              <option value="1">Tăng dần</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2" className="d-flex align-items-center">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </>
  }

  renderTrustedBankVisaTable = () => {
    const { trustedBankVisas } = this.props;
    const { showColumns } = this.state;
    
    const safeVisas = Array.isArray(trustedBankVisas) ? trustedBankVisas.filter(visa => visa != null && typeof visa === 'object') : [];
    
    if (!safeVisas || safeVisas.length === 0) {
      return (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th style={{ width: '60px' }}>STT</th>
              {showColumns.MID && <th>MID</th>}
              {showColumns.bank_name && <th>Tên ngân hàng</th>}
              {showColumns.trust_person_mid && <th>Trust Person MID</th>}
              {showColumns.account_holder_name && <th>Tên chủ thẻ</th>}
              {showColumns.account_holder_name_english && <th>Tên tiếng Anh</th>}
              {showColumns.visa_number && <th>Số Visa</th>}
              {showColumns.valid_month && <th>Tháng hết hạn</th>}
              {showColumns.valid_year && <th>Năm hết hạn</th>}
              {showColumns.type && <th>Loại</th>}
              {showColumns.status && <th>Trạng thái</th>}
              {showColumns.is_active && <th>Hoạt động</th>}
              {showColumns.cvvx && <th>CVVX</th>}
              {showColumns.deposit_bank_account_mid && <th>Deposit Bank Account MID</th>}
              {showColumns.opening_fee && <th>Phí mở tài khoản</th>}
              {showColumns.annual_fee && <th>Phí thường niên</th>}
              {showColumns.created_at && <th>Ngày tạo</th>}
              {showColumns.ref_etsy_info_pack_mid && <th>MID Etsy Info Pack</th>}
              <th style={{ width: '100px' }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(showColumns).filter(Boolean).length + 2} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th style={{ width: '60px' }}>STT</th>
            {showColumns.MID && <th>MID</th>}
            {showColumns.bank_name && <th>Tên ngân hàng</th>}
            {showColumns.trust_person_mid && <th>Trust Person MID</th>}
            {showColumns.account_holder_name && <th>Tên chủ thẻ</th>}
            {showColumns.account_holder_name_english && <th>Tên tiếng Anh</th>}
            {showColumns.visa_number && <th>Số Visa</th>}
            {showColumns.valid_month && <th>Tháng hết hạn</th>}
            {showColumns.valid_year && <th>Năm hết hạn</th>}
            {showColumns.type && <th>Loại</th>}
              {showColumns.status && <th>Trạng thái</th>}
              {showColumns.is_active && <th>Hoạt động</th>}
              {showColumns.cvvx && <th>CVVX</th>}
              {showColumns.deposit_bank_account_mid && <th>Deposit Bank Account MID</th>}
              {showColumns.opening_fee && <th>Phí mở tài khoản</th>}
              {showColumns.annual_fee && <th>Phí thường niên</th>}
              {showColumns.created_at && <th>Ngày tạo</th>}
              {showColumns.ref_etsy_info_pack_mid && <th>MID Etsy Info Pack</th>}
              <th style={{ width: '100px' }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safeVisas.map((visa, index) => {
            if (!visa || typeof visa !== 'object') return null;
              
              return (
                <tr key={visa._id || index}>
                  <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                  {showColumns.MID && (
                    <td>
                      {visa.MID ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                            {visa.MID}
                          </Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => navigator.clipboard.writeText(visa.MID)}
                            title="Copy MID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.bank_name && (
                    <td>
                      <div 
                        className="fw-bold" 
                        style={{ cursor: 'pointer', color: '#007bff' }}
                        onClick={() => {
                          if (visa.bank_brand_info) {
                            this.handleViewBankInfo(visa.bank_brand_info);
                          } else {
                            console.log('No bank_brand_info available for visa:', visa);
                          }
                        }}
                        title="Xem thông tin ngân hàng"
                      >
                        {visa.bank_name || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.trust_person_mid && (
                    <td>
                      {visa.trust_person_mid ? (
                        <Badge 
                          bg="info" 
                          style={{ fontSize: '0.9em', padding: '6px 10px', cursor: 'pointer' }}
                          onClick={() => {
                            if (visa.trusted_person_info) {
                              this.handleViewTrustedPersonInfo(visa.trusted_person_info);
                            } else {
                              console.log('No trusted_person_info available for visa:', visa);
                            }
                          }}
                          title="Xem thông tin Trusted Person"
                        >
                          {visa.trust_person_mid}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.account_holder_name && (
                    <td>
                      <div className="fw-bold">{visa.trusted_person_info?.full_name || '-'}</div>
                    </td>
                  )}
                  {showColumns.account_holder_name_english && (
                    <td>
                      {visa.trusted_person_info?.full_name_english ? (
                        <div className="d-flex align-items-center gap-2">
                          <span>{visa.trusted_person_info.full_name_english}</span>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => navigator.clipboard.writeText(visa.trusted_person_info.full_name_english)}
                            title="Copy English name"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.visa_number && (
                    <td>
                      {visa.visa_number ? (
                        <div className="d-flex align-items-center gap-2">
                          <span>{visa.visa_number}</span>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => navigator.clipboard.writeText(visa.visa_number)}
                            title="Copy Visa number"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.valid_month && (
                    <td>{visa.valid_month || '-'}</td>
                  )}
                  {showColumns.valid_year && (
                    <td>{visa.valid_year || '-'}</td>
                  )}
                  {showColumns.type && (
                    <td>{visa.type || '-'}</td>
                  )}
                  {showColumns.status && (
                    <td>
                      <Badge 
                        bg={visa.status === 'active' ? 'success' : 'danger'} 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {visa.status === 'active' ? 'Hoạt động' : 'Không hoạt động'}
                      </Badge>
                    </td>
                  )}
                  {showColumns.is_active && (
                    <td>
                      <Badge 
                        bg={visa.is_active ? 'success' : 'danger'} 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {visa.is_active ? 'Có' : 'Không'}
                      </Badge>
                    </td>
                  )}
                  {showColumns.cvvx && (
                    <td>
                      {visa.cvvx ? (
                        <div className="d-flex align-items-center gap-2">
                          <span>{visa.cvvx}</span>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => navigator.clipboard.writeText(visa.cvvx)}
                            title="Copy CVVX"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.deposit_bank_account_mid && (
                    <td>
                      {visa.deposit_bank_account_mid ? (
                        <div className="d-flex align-items-center gap-2">
                          <span 
                            style={{ cursor: 'pointer', color: '#007bff' }}
                            onClick={() => {
                              if (visa.deposit_bank_account_info) {
                                this.handleViewDepositAccountInfo(visa.deposit_bank_account_info, visa);
                              } else {
                                console.log('No deposit_bank_account_info available for visa:', visa);
                              }
                            }}
                            title="Xem thông tin Deposit Bank Account"
                          >
                            {visa.deposit_bank_account_mid}
                          </span>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => navigator.clipboard.writeText(visa.deposit_bank_account_mid)}
                            title="Copy Deposit Bank Account MID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.opening_fee && (
                    <td>
                      {visa.opening_fee ? (
                        <span className="text-success fw-bold">
                          {visa.opening_fee.toLocaleString('vi-VN')} VNĐ
                        </span>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.annual_fee && (
                    <td>
                      {visa.annual_fee ? (
                        <span className="text-warning fw-bold">
                          {visa.annual_fee.toLocaleString('vi-VN')} VNĐ
                        </span>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.created_at && (
                    <td>{visa.created_at ? new Date(visa.created_at).toLocaleDateString('vi-VN') : '-'}</td>
                  )}
                  {showColumns.ref_etsy_info_pack_mid && (
                    <td>
                      {visa.ref_etsy_info_pack_mid ? (
                        <Badge 
                          bg="success" 
                          style={{ 
                            fontSize: '0.9em', 
                            padding: '6px 10px', 
                            cursor: 'pointer' 
                          }}
                          onClick={() => this.handleEtsyInfoPackClick(visa.ref_etsy_info_pack_mid)}
                          title="Click để xem chi tiết Etsy Info Pack"
                        >
                          {visa.ref_etsy_info_pack_mid}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <FaEye 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Xem thông tin"
                        onClick={() => this.handleViewClick(visa)}
                      />
                      <FaEdit 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Chỉnh sửa"
                        onClick={() => this.handleEditClick(visa)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                TKT1 Trusted Bank Visa
              </h2>
            </Col>
            <Col className="text-end" md="auto">
              <div className="d-flex gap-2">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => this.setState({ showConfigModal: true })}
                  title="Cấu hình hiển thị"
                >
                  <i className="fas fa-cog me-1"></i>
                  Cấu hình
                </Button>
                <Button
                  variant="success"
                  size="sm"
                  onClick={this.handleCreateClick}
                  title="Thêm thẻ Visa tin cậy mới"
                >
                  <FaPlus /> Thêm mới
                </Button>
              </div>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={(e) => {
                      const itemsPerPage = parseInt(e.target.value);
                      const trimmedQuery = {
                        ...this.state.query,
                        itemsPerPage,
                        currentPage: 1,
                        search: this.state.query.search.trim(),
                        is_active: this.state.query.is_active
                      };
                      
                      const apiQuery = this.prepareApiQuery(trimmedQuery);
                      
                      this.setState({
                        query: { ...this.state.query, itemsPerPage, currentPage: 1 }
                      }, () => {
                        this.updateUrl(trimmedQuery);
                        this.props.getTKT1TrustedBankVisas(apiQuery);
                        localStorage.setItem('tkt1_trusted_bank_visa_query', JSON.stringify(trimmedQuery));
                      })
                    }}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {this.renderTrustedBankVisaTable()}
            </Col>
          </Row>
        </Container>
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Create Modal */}
        <Modal show={this.state.showCreateModal} onHide={this.handleCloseCreateModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-plus me-2"></i>
              Thêm thẻ Visa tin cậy mới
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tên ngân hàng *</Form.Label>
                    <Select
                      value={this.props.bankBrands ? this.props.bankBrands
                        .map((bank) => ({
                          value: bank.bank_name,
                          label: `${bank.bank_name}${bank.vietnamese_name ? ` (${bank.vietnamese_name})` : ''}${bank.bank_short_name ? ` [${bank.bank_short_name}]` : ''}`
                        }))
                        .find(option => option.value === this.state.editFormData.bank_name) : null}
                      onChange={(selectedOption) => this.handleFormChange('bank_name', selectedOption ? selectedOption.value : '')}
                      options={this.props.bankBrands ? this.props.bankBrands.map((bank) => ({
                        value: bank.bank_name,
                        label: `${bank.bank_name}${bank.vietnamese_name ? ` (${bank.vietnamese_name})` : ''}${bank.bank_short_name ? ` [${bank.bank_short_name}]` : ''}`
                      })) : []}
                      placeholder="Chọn ngân hàng..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy ngân hàng"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Trust Person MID *</Form.Label>
                    <Select
                      value={this.props.trustedPersonInfos ? this.props.trustedPersonInfos
                        .map((person) => ({
                          value: person.MID,
                          label: `${person.MID} - ${person.full_name}${person.full_name_english ? ` (${person.full_name_english})` : ''}`
                        }))
                        .find(option => option.value === this.state.editFormData.trust_person_mid) : null}
                      onChange={(selectedOption) => this.handleFormChange('trust_person_mid', selectedOption ? selectedOption.value : '')}
                      options={this.props.trustedPersonInfos ? this.props.trustedPersonInfos.map((person) => ({
                        value: person.MID,
                        label: `${person.MID} - ${person.full_name}${person.full_name_english ? ` (${person.full_name_english})` : ''}`
                      })) : []}
                      placeholder="Chọn Trust Person..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy Trust Person"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Số Visa *</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.visa_number}
                      onChange={(e) => this.handleFormChange('visa_number', e.target.value)}
                      placeholder="Nhập số Visa"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Chi nhánh</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.branch_name}
                      onChange={(e) => this.handleFormChange('branch_name', e.target.value)}
                      placeholder="Nhập tên chi nhánh"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Loại Visa</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.type}
                      onChange={(e) => this.handleFormChange('type', e.target.value)}
                      placeholder="Nhập loại Visa"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleFormChange('status', e.target.value)}
                    >
                      <option value="active">Hoạt động</option>
                      <option value="inactive">Không hoạt động</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="4">
                  <Form.Group className="mb-3">
                    <Form.Label>Tháng hết hạn</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.valid_month}
                      onChange={(e) => this.handleFormChange('valid_month', e.target.value)}
                    >
                      <option value="">Chọn tháng</option>
                      {Array.from({ length: 12 }, (_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {i + 1}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="4">
                  <Form.Group className="mb-3">
                    <Form.Label>Năm hết hạn</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.editFormData.valid_year}
                      onChange={(e) => this.handleFormChange('valid_year', e.target.value)}
                      placeholder="Nhập năm hết hạn"
                      min="2024"
                      max="2030"
                    />
                  </Form.Group>
                </Col>
                <Col md="4">
                  <Form.Group className="mb-3">
                    <Form.Label>CVVX</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.cvvx}
                      onChange={(e) => this.handleFormChange('cvvx', e.target.value)}
                      placeholder="Nhập CVVX (6 chữ số)"
                      maxLength="6"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Deposit Bank Account MID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.deposit_bank_account_mid}
                      onChange={(e) => this.handleFormChange('deposit_bank_account_mid', e.target.value)}
                      placeholder="Nhập Deposit Bank Account MID"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Reference Etsy Info Pack MID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ref_etsy_info_pack_mid}
                      onChange={(e) => this.handleFormChange('ref_etsy_info_pack_mid', e.target.value)}
                      placeholder="Nhập Reference Etsy Info Pack MID"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Phí mở tài khoản (VNĐ)</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.editFormData.opening_fee}
                      onChange={(e) => this.handleFormChange('opening_fee', parseFloat(e.target.value) || 0)}
                      placeholder="Nhập phí mở tài khoản"
                      min="0"
                      step="1000"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Phí thường niên (VNĐ)</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.editFormData.annual_fee}
                      onChange={(e) => this.handleFormChange('annual_fee', parseFloat(e.target.value) || 0)}
                      placeholder="Nhập phí thường niên"
                      min="0"
                      step="1000"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Ghi chú Visa</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.account_note}
                      onChange={(e) => this.handleFormChange('account_note', e.target.value)}
                      placeholder="Nhập ghi chú về Visa"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Hoạt động"
                      checked={this.state.editFormData.is_active}
                      onChange={(e) => this.handleFormChange('is_active', e.target.checked)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseCreateModal}>
              <i className="fas fa-times me-1"></i>
              Hủy
            </Button>
            <Button 
              variant="primary" 
              onClick={this.handleSubmitEdit}
              disabled={this.state.loading}
            >
              {this.state.loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Đang lưu...
                </>
              ) : (
                <>
                  <i className="fas fa-save me-1"></i>
                  Lưu
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Modal */}
        <Modal show={this.state.showViewModal} onHide={this.handleCloseViewModal} size="lg">
          <Modal.Header closeButton className="bg-info text-white">
            <Modal.Title>
              <i className="fas fa-eye me-2"></i>
              Thông tin thẻ Visa tin cậy
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedVisa && (
              <div>
                <Row>
                  <Col md="6">
                    <Card className="mb-3">
                      <Card.Header className="bg-primary text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h6 className="mb-0">
                          <i className="fas fa-university me-2"></i>
                          Thông tin ngân hàng
                        </h6>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">
                                <i className="fas fa-building me-1"></i>
                                Tên ngân hàng
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedVisa.bank_name || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">
                                <i className="fas fa-map-marker-alt me-1"></i>
                                Chi nhánh
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedVisa.branch_name || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">
                                <i className="fas fa-tag me-1"></i>
                                Loại Visa
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedVisa.type || '-'}</p>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md="6">
                    <Card className="mb-3">
                      <Card.Header className="bg-success text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h6 className="mb-0">
                          <i className="fas fa-credit-card me-2"></i>
                          Thông tin Visa
                        </h6>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">
                                <i className="fas fa-id-card me-1"></i>
                                Trust Person MID
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedVisa.trust_person_mid || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">
                                <i className="fas fa-credit-card me-1"></i>
                                Số Visa
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedVisa.visa_number || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">
                                <i className="fas fa-calendar me-1"></i>
                                Hết hạn
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">
                                {this.state.selectedVisa.valid_month && this.state.selectedVisa.valid_year 
                                  ? `${this.state.selectedVisa.valid_month}/${this.state.selectedVisa.valid_year}` 
                                  : '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <Card className="mb-3">
                      <Card.Header className="bg-warning text-dark" style={{ padding: '0.75rem 1rem' }}>
                        <h6 className="mb-0">
                          <i className="fas fa-info-circle me-2"></i>
                          Trạng thái & Bảo mật
                        </h6>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">
                                <i className="fas fa-check-circle me-1"></i>
                                Trạng thái
                              </label>
                            </div>
                            <div className="col-8">
                              <Badge 
                                bg={this.state.selectedVisa.status === 'active' ? 'success' : 'danger'} 
                                style={{ fontSize: '0.8em', padding: '4px 8px' }}
                              >
                                {this.state.selectedVisa.status === 'active' ? 'Hoạt động' : 'Không hoạt động'}
                              </Badge>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">
                                <i className="fas fa-toggle-on me-1"></i>
                                Hoạt động
                              </label>
                            </div>
                            <div className="col-8">
                              <Badge 
                                bg={this.state.selectedVisa.is_active ? 'success' : 'danger'} 
                                style={{ fontSize: '0.8em', padding: '4px 8px' }}
                              >
                                {this.state.selectedVisa.is_active ? 'Có' : 'Không'}
                              </Badge>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">
                                <i className="fas fa-shield-alt me-1"></i>
                                CVVX
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedVisa.cvvx ? '••••••' : '-'}</p>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md="6">
                    <Card className="mb-3">
                      <Card.Header className="bg-info text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h6 className="mb-0">
                          <i className="fas fa-sticky-note me-2"></i>
                          Ghi chú & Tham chiếu
                        </h6>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">
                                <i className="fas fa-comment me-1"></i>
                                Ghi chú Visa
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0 text-muted small">{this.state.selectedVisa.account_note || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">
                                <i className="fas fa-link me-1"></i>
                                Deposit Bank Account MID
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedVisa.deposit_bank_account_mid || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">
                                <i className="fas fa-link me-1"></i>
                                Etsy Info Pack MID
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedVisa.ref_etsy_info_pack_mid || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">
                                <i className="fas fa-clock me-1"></i>
                                Ngày tạo
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedVisa.created_at ? new Date(this.state.selectedVisa.created_at).toLocaleDateString('vi-VN') : '-'}</p>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="bg-light">
            <Button variant="secondary" onClick={this.handleCloseViewModal}>
              <i className="fas fa-times me-1"></i>
              Đóng
            </Button>
            <Button variant="primary" onClick={() => {
              this.handleCloseViewModal();
              this.handleEditClick(this.state.selectedVisa);
            }}>
              <i className="fas fa-edit me-1"></i>
              Chỉnh sửa
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal show={this.state.showEditModal} onHide={this.handleCloseEditModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-edit me-2"></i>
              Chỉnh sửa thẻ Visa tin cậy
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Tên ngân hàng *</Form.Label>
                    <Select
                      value={this.props.bankBrands ? this.props.bankBrands
                        .map((bank) => ({
                          value: bank.bank_name,
                          label: `${bank.bank_name}${bank.vietnamese_name ? ` (${bank.vietnamese_name})` : ''}${bank.bank_short_name ? ` [${bank.bank_short_name}]` : ''}`
                        }))
                        .find(option => option.value === this.state.editFormData.bank_name) : null}
                      onChange={(selectedOption) => this.handleFormChange('bank_name', selectedOption ? selectedOption.value : '')}
                      options={this.props.bankBrands ? this.props.bankBrands.map((bank) => ({
                        value: bank.bank_name,
                        label: `${bank.bank_name}${bank.vietnamese_name ? ` (${bank.vietnamese_name})` : ''}${bank.bank_short_name ? ` [${bank.bank_short_name}]` : ''}`
                      })) : []}
                      placeholder="Chọn ngân hàng..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy ngân hàng"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Trust Person MID *</Form.Label>
                    <Select
                      value={this.props.trustedPersonInfos ? this.props.trustedPersonInfos
                        .map((person) => ({
                          value: person.MID,
                          label: `${person.MID} - ${person.full_name}${person.full_name_english ? ` (${person.full_name_english})` : ''}`
                        }))
                        .find(option => option.value === this.state.editFormData.trust_person_mid) : null}
                      onChange={(selectedOption) => this.handleFormChange('trust_person_mid', selectedOption ? selectedOption.value : '')}
                      options={this.props.trustedPersonInfos ? this.props.trustedPersonInfos.map((person) => ({
                        value: person.MID,
                        label: `${person.MID} - ${person.full_name}${person.full_name_english ? ` (${person.full_name_english})` : ''}`
                      })) : []}
                      placeholder="Chọn Trust Person..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy Trust Person"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Số Visa *</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.visa_number}
                      onChange={(e) => this.handleFormChange('visa_number', e.target.value)}
                      placeholder="Nhập số Visa"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Chi nhánh</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.branch_name}
                      onChange={(e) => this.handleFormChange('branch_name', e.target.value)}
                      placeholder="Nhập tên chi nhánh"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Loại Visa</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.type}
                      onChange={(e) => this.handleFormChange('type', e.target.value)}
                      placeholder="Nhập loại Visa"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleFormChange('status', e.target.value)}
                    >
                      <option value="active">Hoạt động</option>
                      <option value="inactive">Không hoạt động</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="4">
                  <Form.Group className="mb-3">
                    <Form.Label>Tháng hết hạn</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.valid_month}
                      onChange={(e) => this.handleFormChange('valid_month', e.target.value)}
                    >
                      <option value="">Chọn tháng</option>
                      {Array.from({ length: 12 }, (_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {i + 1}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="4">
                  <Form.Group className="mb-3">
                    <Form.Label>Năm hết hạn</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.editFormData.valid_year}
                      onChange={(e) => this.handleFormChange('valid_year', e.target.value)}
                      placeholder="Nhập năm hết hạn"
                      min="2024"
                      max="2030"
                    />
                  </Form.Group>
                </Col>
                <Col md="4">
                  <Form.Group className="mb-3">
                    <Form.Label>CVVX</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.cvvx}
                      onChange={(e) => this.handleFormChange('cvvx', e.target.value)}
                      placeholder="Nhập CVVX (6 chữ số)"
                      maxLength="6"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Deposit Bank Account MID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.deposit_bank_account_mid}
                      onChange={(e) => this.handleFormChange('deposit_bank_account_mid', e.target.value)}
                      placeholder="Nhập Deposit Bank Account MID"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Reference Etsy Info Pack MID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ref_etsy_info_pack_mid}
                      onChange={(e) => this.handleFormChange('ref_etsy_info_pack_mid', e.target.value)}
                      placeholder="Nhập Reference Etsy Info Pack MID"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Phí mở tài khoản (VNĐ)</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.editFormData.opening_fee}
                      onChange={(e) => this.handleFormChange('opening_fee', parseFloat(e.target.value) || 0)}
                      placeholder="Nhập phí mở tài khoản"
                      min="0"
                      step="1000"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Phí thường niên (VNĐ)</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.editFormData.annual_fee}
                      onChange={(e) => this.handleFormChange('annual_fee', parseFloat(e.target.value) || 0)}
                      placeholder="Nhập phí thường niên"
                      min="0"
                      step="1000"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Ghi chú Visa</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.account_note}
                      onChange={(e) => this.handleFormChange('account_note', e.target.value)}
                      placeholder="Nhập ghi chú về Visa"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Hoạt động"
                      checked={this.state.editFormData.is_active}
                      onChange={(e) => this.handleFormChange('is_active', e.target.checked)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              <i className="fas fa-times me-1"></i>
              Hủy
            </Button>
            <Button 
              variant="primary" 
              onClick={this.handleSubmitEdit}
              disabled={this.state.loading}
            >
              {this.state.loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Đang lưu...
                </>
              ) : (
                <>
                  <i className="fas fa-save me-1"></i>
                  Lưu
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Config Modal */}
        <Modal show={this.state.showConfigModal} onHide={this.handleCloseConfigModal} size="md">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-cog me-2"></i>
              Cấu hình hiển thị cột
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <h6 className="text-muted">Chọn các cột muốn hiển thị trong bảng:</h6>
            </div>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="MID"
                  label="MID"
                  checked={this.state.showColumns.MID}
                  onChange={(e) => this.handleConfigChange('MID', e.target.checked)}
                />
              </Col>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="bank_name"
                  label="Tên ngân hàng"
                  checked={this.state.showColumns.bank_name}
                  onChange={(e) => this.handleConfigChange('bank_name', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="trust_person_mid"
                  label="Trust Person MID"
                  checked={this.state.showColumns.trust_person_mid}
                  onChange={(e) => this.handleConfigChange('trust_person_mid', e.target.checked)}
                />
              </Col>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="account_holder_name"
                  label="Tên chủ thẻ"
                  checked={this.state.showColumns.account_holder_name}
                  onChange={(e) => this.handleConfigChange('account_holder_name', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="account_holder_name_english"
                  label="Tên tiếng Anh"
                  checked={this.state.showColumns.account_holder_name_english}
                  onChange={(e) => this.handleConfigChange('account_holder_name_english', e.target.checked)}
                />
              </Col>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="visa_number"
                  label="Số Visa"
                  checked={this.state.showColumns.visa_number}
                  onChange={(e) => this.handleConfigChange('visa_number', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="valid_month"
                  label="Tháng hết hạn"
                  checked={this.state.showColumns.valid_month}
                  onChange={(e) => this.handleConfigChange('valid_month', e.target.checked)}
                />
              </Col>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="valid_year"
                  label="Năm hết hạn"
                  checked={this.state.showColumns.valid_year}
                  onChange={(e) => this.handleConfigChange('valid_year', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="type"
                  label="Loại"
                  checked={this.state.showColumns.type}
                  onChange={(e) => this.handleConfigChange('type', e.target.checked)}
                />
              </Col>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="status"
                  label="Trạng thái"
                  checked={this.state.showColumns.status}
                  onChange={(e) => this.handleConfigChange('status', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="is_active"
                  label="Hoạt động"
                  checked={this.state.showColumns.is_active}
                  onChange={(e) => this.handleConfigChange('is_active', e.target.checked)}
                />
              </Col>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="cvvx"
                  label="CVVX"
                  checked={this.state.showColumns.cvvx}
                  onChange={(e) => this.handleConfigChange('cvvx', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="deposit_bank_account_mid"
                  label="Deposit Bank Account MID"
                  checked={this.state.showColumns.deposit_bank_account_mid}
                  onChange={(e) => this.handleConfigChange('deposit_bank_account_mid', e.target.checked)}
                />
              </Col>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="opening_fee"
                  label="Phí mở tài khoản"
                  checked={this.state.showColumns.opening_fee}
                  onChange={(e) => this.handleConfigChange('opening_fee', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="annual_fee"
                  label="Phí thường niên"
                  checked={this.state.showColumns.annual_fee}
                  onChange={(e) => this.handleConfigChange('annual_fee', e.target.checked)}
                />
              </Col>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="created_at"
                  label="Ngày tạo"
                  checked={this.state.showColumns.created_at}
                  onChange={(e) => this.handleConfigChange('created_at', e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Check
                  type="checkbox"
                  id="ref_etsy_info_pack_mid"
                  label="MID Etsy Info Pack"
                  checked={this.state.showColumns.ref_etsy_info_pack_mid}
                  onChange={(e) => this.handleConfigChange('ref_etsy_info_pack_mid', e.target.checked)}
                />
              </Col>
            </Row>
            <hr />
            <div className="d-flex gap-2">
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => {
                  const allColumns = {
                    MID: true,
                    bank_name: true,
                    trust_person_mid: true,
                    account_holder_name: true,
                    account_holder_name_english: true,
                    visa_number: true,
                    valid_month: true,
                    valid_year: true,
                    type: true,
                    status: true,
                    is_active: true,
                    cvvx: false,
                    deposit_bank_account_mid: false,
                    opening_fee: false,
                    annual_fee: false,
                    created_at: false
                  };
                  this.setState({ showColumns: allColumns });
                }}
              >
                <i className="fas fa-check-double me-1"></i>
                Chọn tất cả
              </Button>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => {
                  const noColumns = {
                    MID: false,
                    bank_name: false,
                    trust_person_mid: false,
                    account_holder_name: false,
                    account_holder_name_english: false,
                    visa_number: false,
                    valid_month: false,
                    valid_year: false,
                    type: false,
                    status: false,
                    is_active: false,
                    cvvx: false,
                    deposit_bank_account_mid: false,
                    opening_fee: false,
                    annual_fee: false,
                    created_at: false
                  };
                  this.setState({ showColumns: noColumns });
                }}
              >
                <i className="fas fa-times me-1"></i>
                Bỏ chọn tất cả
              </Button>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseConfigModal}>
              <i className="fas fa-times me-1"></i>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveConfig}>
              <i className="fas fa-save me-1"></i>
              Lưu cấu hình
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Bank Info Modal */}
        <Modal show={this.state.showBankInfoModal} onHide={this.handleCloseBankInfoModal} size="xl">
          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title>
              <i className="fas fa-university me-2"></i>
              Thông tin ngân hàng
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            {this.state.selectedBankInfo && (
              <div>
                {/* Header with Logo and Basic Info */}
                <div className="bg-light p-4 border-bottom">
                  <Row className="align-items-center">
                    <Col md="3" className="text-center">
                      {this.state.selectedBankInfo.logo ? (
                        <Image 
                          src={this.state.selectedBankInfo.logo} 
                          alt={this.state.selectedBankInfo.logo_alt_text || this.state.selectedBankInfo.bank_name} 
                          style={{ 
                            width: '240px', 
                            height: '120px',
                            objectFit: 'contain'
                          }}
                          className="border rounded p-3 bg-white"
                        />
                      ) : (
                        <div className="border rounded p-4 bg-white text-muted">
                          <i className="fas fa-university fa-3x"></i>
                          <div className="mt-2">Không có logo</div>
                        </div>
                      )}
                    </Col>
                    <Col md="9">
                      <h3 className="text-primary mb-2">{this.state.selectedBankInfo.bank_name || '-'}</h3>
                      <div className="d-flex flex-wrap gap-2 mb-2">
                        {this.state.selectedBankInfo.bank_code && (
                          <Badge bg="info" className="fs-6 px-3 py-2">
                            <i className="fas fa-code me-1"></i>
                            {this.state.selectedBankInfo.bank_code}
                          </Badge>
                        )}
                        {this.state.selectedBankInfo.bin && (
                          <Badge bg="secondary" className="fs-6 px-3 py-2">
                            <i className="fas fa-credit-card me-1"></i>
                            BIN: {this.state.selectedBankInfo.bin}
                          </Badge>
                        )}
                        {this.state.selectedBankInfo.is_active !== undefined && (
                          <Badge bg={this.state.selectedBankInfo.is_active ? 'success' : 'danger'} className="fs-6 px-3 py-2">
                            <i className={`fas fa-${this.state.selectedBankInfo.is_active ? 'check' : 'times'}-circle me-1`}></i>
                            {this.state.selectedBankInfo.is_active ? 'Hoạt động' : 'Không hoạt động'}
                          </Badge>
                        )}
                      </div>
                      {this.state.selectedBankInfo.short_name && (
                        <p className="text-muted mb-0">
                          <i className="fas fa-tag me-1"></i>
                          <strong>Tên viết tắt:</strong> {this.state.selectedBankInfo.short_name}
                        </p>
                      )}
                    </Col>
                  </Row>
                </div>

                {/* Main Content */}
                <div className="p-4">
                  <Row>
                    {/* Left Column */}
                    <Col md="6">
                      <Card className="h-100">
                        <Card.Header className="bg-primary text-white" style={{ padding: '0.75rem 1rem' }}>
                          <h5 className="mb-0">
                            <i className="fas fa-info-circle me-2"></i>
                            Thông tin cơ bản
                          </h5>
                        </Card.Header>
                        <Card.Body style={{ padding: '0.75rem 1rem' }}>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-4">
                                <label className="form-label fw-bold text-primary">
                                  <i className="fas fa-language me-1"></i>
                                  Tên tiếng Việt
                                </label>
                              </div>
                              <div className="col-8">
                                <p className="mb-0">{this.state.selectedBankInfo.vietnamese_name || '-'}</p>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-4">
                                <label className="form-label fw-bold text-primary">
                                  <i className="fas fa-globe me-1"></i>
                                  Tên tiếng Anh
                                </label>
                              </div>
                              <div className="col-8">
                                <div className="d-flex align-items-center gap-2">
                                  <span>{this.state.selectedBankInfo.english_name || '-'}</span>
                                  {this.state.selectedBankInfo.english_name && (
                                    <FaCopy 
                                      size={12} 
                                      style={{ cursor: 'pointer', color: '#6c757d' }}
                                      onClick={() => navigator.clipboard.writeText(this.state.selectedBankInfo.english_name)}
                                      title="Copy English name"
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-4">
                                <label className="form-label fw-bold text-primary">
                                  <i className="fas fa-code me-1"></i>
                                  Mã SWIFT
                                </label>
                              </div>
                              <div className="col-8">
                                <div className="d-flex align-items-center gap-2">
                                  <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                    {this.state.selectedBankInfo.swift_code || '-'}
                                  </Badge>
                                  {this.state.selectedBankInfo.swift_code && (
                                    <FaCopy 
                                      size={12} 
                                      style={{ cursor: 'pointer', color: '#6c757d' }}
                                      onClick={() => navigator.clipboard.writeText(this.state.selectedBankInfo.swift_code)}
                                      title="Copy SWIFT code"
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-4">
                                <label className="form-label fw-bold text-primary">
                                  <i className="fas fa-user me-1"></i>
                                  Đầu mối contact
                                </label>
                              </div>
                              <div className="col-8">
                                <p className="mb-0">{this.state.selectedBankInfo.contact_person || '-'}</p>
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                    {/* Right Column */}
                    <Col md="6">
                      <Card className="h-100">
                        <Card.Header className="bg-success text-white" style={{ padding: '0.75rem 1rem' }}>
                          <h5 className="mb-0">
                            <i className="fas fa-credit-card me-2"></i>
                            Thông tin dịch vụ
                          </h5>
                        </Card.Header>
                        <Card.Body style={{ padding: '0.75rem 1rem' }}>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-4">
                                <label className="form-label fw-bold text-success">
                                  <i className="fas fa-laptop me-1"></i>
                                  Có thể đăng ký online
                                </label>
                              </div>
                              <div className="col-8">
                                {this.state.selectedBankInfo.can_register_online ? (
                                  <Badge bg="success" className="fs-6">
                                    <i className="fas fa-check me-1"></i>
                                    {this.state.selectedBankInfo.can_register_online}
                                  </Badge>
                                ) : '-'}
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-4">
                                <label className="form-label fw-bold text-success">
                                  <i className="fas fa-dollar-sign me-1"></i>
                                  Chi phí thẻ VISA
                                </label>
                              </div>
                              <div className="col-8">
                                <p className="mb-0 text-muted small">{this.state.selectedBankInfo.visa_card_cost || '-'}</p>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-4">
                                <label className="form-label fw-bold text-success">
                                  <i className="fas fa-building me-1"></i>
                                  Số bank tối đa
                                </label>
                              </div>
                              <div className="col-8">
                                <p className="mb-0">{this.state.selectedBankInfo.max_banks || '-'}</p>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <div className="row">
                              <div className="col-4">
                                <label className="form-label fw-bold text-success">
                                  <i className="fas fa-credit-card me-1"></i>
                                  Số thẻ VISA debit tối đa
                                </label>
                              </div>
                              <div className="col-8">
                                <p className="mb-0">{this.state.selectedBankInfo.max_visa_debit_cards || '-'}</p>
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>

                  {/* Additional Information */}
                  <Row className="mt-4">
                    <Col>
                      <Card>
                          <Card.Header className="bg-warning text-dark" style={{ padding: '0.75rem 1rem' }}>
                            <h5 className="mb-0">
                              <i className="fas fa-sticky-note me-2"></i>
                              Thông tin bổ sung
                            </h5>
                          </Card.Header>
                          <Card.Body style={{ padding: '0.75rem 1rem' }}>
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-warning">
                                    <i className="fas fa-edit me-1"></i>
                                    Ghi chú đăng ký
                                  </label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0 text-muted small">{this.state.selectedBankInfo.register_note || '-'}</p>
                                </div>
                              </div>
                            </div>
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-warning">
                                    <i className="fas fa-shopping-cart me-1"></i>
                                    Ghi chú Etsy
                                  </label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0 text-muted small">{this.state.selectedBankInfo.etsy_note || '-'}</p>
                                </div>
                              </div>
                            </div>
                            {this.state.selectedBankInfo.ninepay_vietinbank_connection && (
                              <div className="mb-3">
                                <div className="row">
                                  <div className="col-4">
                                    <label className="form-label fw-bold text-warning">
                                      <i className="fas fa-link me-1"></i>
                                      Kết nối 9Pay/VietinBank
                                    </label>
                                  </div>
                                  <div className="col-8">
                                    <p className="mb-0 text-muted small">{this.state.selectedBankInfo.ninepay_vietinbank_connection}</p>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.selectedBankInfo.tags && (
                              <div className="mb-3">
                                <div className="row">
                                  <div className="col-4">
                                    <label className="form-label fw-bold text-warning">
                                      <i className="fas fa-tags me-1"></i>
                                      Tags
                                    </label>
                                  </div>
                                  <div className="col-8">
                                    <div>
                                      {this.state.selectedBankInfo.tags.split(',').map((tag, index) => (
                                        <Badge key={index} bg="light" text="dark" className="me-1 mb-1">
                                          {tag.trim()}
                                        </Badge>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.selectedBankInfo.display_name && (
                              <div className="mb-3">
                                <div className="row">
                                  <div className="col-4">
                                    <label className="form-label fw-bold text-warning">
                                      <i className="fas fa-eye me-1"></i>
                                      Tên hiển thị
                                    </label>
                                  </div>
                                  <div className="col-8">
                                    <p className="mb-0 text-muted small">{this.state.selectedBankInfo.display_name}</p>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="bg-light">
            <Button variant="secondary" onClick={this.handleCloseBankInfoModal}>
              <i className="fas fa-times me-1"></i>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Trusted Person Info Modal */}
        <TrustedPersonInfoModal
          show={this.state.showTrustedPersonModal}
          onHide={this.handleCloseTrustedPersonModal}
          trustedPersonInfo={this.state.selectedTrustedPersonInfo}
          isEditMode={false}
          hideStatistics={true}
        />

        {/* Deposit Account Info Modal */}
        <Modal show={this.state.showDepositAccountModal} onHide={this.handleCloseDepositAccountModal} size="xl">
          <Modal.Header closeButton className="bg-info text-white">
            <Modal.Title>
              <i className="fas fa-university me-2"></i>
              Thông tin Deposit Bank Account
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedDepositAccountInfo && (
              <div>
                <Row>
                  <Col md="6">
                    <Card className="mb-3">
                      <Card.Header className="bg-primary text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h6 className="mb-0">
                          <i className="fas fa-university me-2"></i>
                          Thông tin ngân hàng
                        </h6>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">
                                <i className="fas fa-building me-1"></i>
                                Tên ngân hàng
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedDepositAccountInfo.bank_short_name || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">
                                <i className="fas fa-flag me-1"></i>
                                Tên tiếng Việt
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedVisa?.bank_brand_info?.vietnamese_name || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">
                                <i className="fas fa-globe me-1"></i>
                                Tên tiếng Anh
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedVisa?.bank_brand_info?.english_name || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">
                                <i className="fas fa-code me-1"></i>
                                Mã ngân hàng
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedVisa?.bank_brand_info?.bank_code || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">
                                <i className="fas fa-map-marker-alt me-1"></i>
                                Chi nhánh
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedDepositAccountInfo.branch_name || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">
                                <i className="fas fa-tag me-1"></i>
                                Loại tài khoản
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedDepositAccountInfo.type || '-'}</p>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md="6">
                    <Card className="mb-3">
                      <Card.Header className="bg-success text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h6 className="mb-0">
                          <i className="fas fa-credit-card me-2"></i>
                          Thông tin tài khoản
                        </h6>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">
                                <i className="fas fa-id-card me-1"></i>
                                Trust Person MID
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedDepositAccountInfo.trust_person_mid || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">
                                <i className="fas fa-user me-1"></i>
                                Tên chủ tài khoản
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0 fw-bold">{this.state.selectedVisa?.trusted_person_info?.full_name || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">
                                <i className="fas fa-globe me-1"></i>
                                Tên tiếng Anh
                              </label>
                            </div>
                            <div className="col-8">
                              <div className="d-flex align-items-center gap-2">
                                <span>{this.state.selectedVisa?.trusted_person_info?.full_name_english || '-'}</span>
                                {this.state.selectedVisa?.trusted_person_info?.full_name_english && (
                                  <FaCopy 
                                    size={12} 
                                    style={{ cursor: 'pointer', color: '#6c757d' }}
                                    onClick={() => navigator.clipboard.writeText(this.state.selectedVisa.trusted_person_info.full_name_english)}
                                    title="Copy English name"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">
                                <i className="fas fa-credit-card me-1"></i>
                                Loại Visa
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">
                                {this.state.selectedVisa?.type ? (
                                  <Badge 
                                    bg={this.state.selectedVisa.type === 'DEBIT' ? 'info' : 'warning'} 
                                    style={{ fontSize: '0.8em', padding: '4px 8px' }}
                                  >
                                    {this.state.selectedVisa.type}
                                  </Badge>
                                ) : '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">
                                <i className="fas fa-credit-card me-1"></i>
                                Số tài khoản
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedDepositAccountInfo.account_number || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">
                                <i className="fas fa-hashtag me-1"></i>
                                MID
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedDepositAccountInfo.mid || '-'}</p>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <Card className="mb-3">
                      <Card.Header className="bg-warning text-dark" style={{ padding: '0.75rem 1rem' }}>
                        <h6 className="mb-0">
                          <i className="fas fa-info-circle me-2"></i>
                          Trạng thái & Thông tin bổ sung
                        </h6>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">
                                <i className="fas fa-check-circle me-1"></i>
                                Trạng thái
                              </label>
                            </div>
                            <div className="col-8">
                              <Badge 
                                bg={this.state.selectedDepositAccountInfo.status === 'active' ? 'success' : 'danger'} 
                                style={{ fontSize: '0.8em', padding: '4px 8px' }}
                              >
                                {this.state.selectedDepositAccountInfo.status === 'active' ? 'Hoạt động' : 'Không hoạt động'}
                              </Badge>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">
                                <i className="fas fa-toggle-on me-1"></i>
                                Hoạt động
                              </label>
                            </div>
                            <div className="col-8">
                              <Badge 
                                bg={this.state.selectedDepositAccountInfo.is_active ? 'success' : 'danger'} 
                                style={{ fontSize: '0.8em', padding: '4px 8px' }}
                              >
                                {this.state.selectedDepositAccountInfo.is_active ? 'Có' : 'Không'}
                              </Badge>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md="6">
                    <Card className="mb-3">
                      <Card.Header className="bg-info text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h6 className="mb-0">
                          <i className="fas fa-sticky-note me-2"></i>
                          Ghi chú & Tham chiếu
                        </h6>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">
                                <i className="fas fa-comment me-1"></i>
                                Ghi chú tài khoản
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0 text-muted small">{this.state.selectedDepositAccountInfo.account_note || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">
                                <i className="fas fa-link me-1"></i>
                                Etsy Info Pack MID
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedDepositAccountInfo.ref_etsy_info_pack_mid || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">
                                <i className="fas fa-clock me-1"></i>
                                Ngày tạo
                              </label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedDepositAccountInfo.created_at ? new Date(this.state.selectedDepositAccountInfo.created_at).toLocaleDateString('vi-VN') : '-'}</p>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="bg-light">
            <Button variant="secondary" onClick={this.handleCloseDepositAccountModal}>
              <i className="fas fa-times me-1"></i>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Toast Notification */}
        <ToastContainer position="top-end" className="p-3">
          <Toast 
            show={this.state.showToast} 
            onClose={() => this.setState({ showToast: false })}
            bg={this.state.toastType === 'success' ? 'success' : 'danger'}
            autohide
            delay={3000}
          >
            <Toast.Header>
              <i className={`fas fa-${this.state.toastType === 'success' ? 'check-circle' : 'exclamation-triangle'} me-2`}></i>
              <strong className="me-auto">
                {this.state.toastType === 'success' ? 'Thành công' : 'Lỗi'}
              </strong>
            </Toast.Header>
            <Toast.Body className="text-white">
              {this.state.toastMessage}
            </Toast.Body>
          </Toast>
        </ToastContainer>

        {/* Iframe Modal */}
        <IframeModal
          show={this.state.showIframeModal}
          onHide={this.handleCloseIframeModal}
          url={this.state.iframeUrl}
          title={this.state.iframeTitle}
          showSidebar={false}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    trustedBankVisas: state.tkt1TrustedBankVisaReducer.trustedBankVisas,
    totalCount: state.tkt1TrustedBankVisaReducer.totalCount,
    bankBrands: state.tkt1BankBrandReducer.bankBrands,
    trustedPersonInfos: state.tkt1TrustedPersonReducer.trustedPersonInfos
  };
};

export default connect(mapStateToProps, { 
  getTKT1TrustedBankVisas,
  updateTKT1TrustedBankVisa,
  createTKT1TrustedBankVisa,
  getTKT1BankBrands,
  getTKT1TrustedPersonInfos
})(TKT1TrustedBankVisa);
